import { gql } from "@apollo/client";

export const GET_CYBER_FLAG = gql`
  query GetCyberFlag {
    isCyberHubEnabled
  }
`;

export const TOGGLE_FEATURE = gql`
  mutation ToggleFeatureFlag($data: ToggleFlagInput!) {
    toggleFeatureFlag(data: $data){
      uuid
    }
  }
`;